<template>
  <WordDisplay @onRowClick="rowClickHandler" :config="lyricConfig" :partNum="partNum">
  </WordDisplay>
</template>
<script>
import WordDisplay from 'business/WordDisplay';
import Lyric from 'libs/lyric-parser'
import helpers from 'dom-helpers';
import { mapGetters } from "vuex";


const CHAR_REG = /[。，;；：？！……——]+/;
const CHAR_REG_LEFT = /^[《。，;；：？！……——“（、]+/; // 标点符号在左边
const CHAR_REG_RIGHT = /[》。，;；：？！……——”）、]+$/; // 标点符号在右边
const ZH_REG = /[\u4e00-\u9fa5]/;
const CHAR_REG_FULL_HALF = /[<>.,;:?!""]+/
export default {
  components: {
    WordDisplay
  },
  props: {
    txts: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  watch: {
    options(newVal, oldVal) {
      this.init();
    },
  },
  computed: {
    ...mapGetters(["getKnowledgeSettings"]),
    lyricConfig() {
      let result = this.result;
      let options = this.options;
      return {
        ...result,
        maxRow: 4,
        canClickRow: options.canClickRow && result.isHasTime,
        isWrite: options.isWrite,
        isScale: options.type == 1,
        currentLineNum: this.currentLineNum
      }
    }
  },
  data() {
    return {
      result: {},
      displayLine: {},
      currentLineNum: -1,
      partNum: -1,
      wordMap: {}
    }
  },
  created() {
    if (sessionStorage.getItem('evalReport')) {
      const report = JSON.parse(sessionStorage.getItem('evalReport')) || {};
      this.wordMap = report?.wordMap || {};
    }
    this.init();
  },
  methods: {
    init() {
      this._isPlay = false;
      this._timeBuff = 1200;
      this._isUpdateDuration = false;
      this._isHasTime = false;
      this._result = {};
      this.currentLineNum = -1;
      this._cacheLineHeights = {} // 行高度缓存
      this.stop()
      if (this.txts) {
        this.createLyric();
      }
    },
    getDisplayLines() {
      return this.displayLines;
    },
    createLyric() {
      let { txts } = this;
      let result = this.parse(txts);
      let { lyricText, isHasTime } = result
      this._isHasTime = isHasTime;
      if (lyricText) {
        if (isHasTime) {
          this._lyric = new Lyric(lyricText, (p) => {
            this.handleLyric(p);
          });
          result = this.calcPlayLines(result);
        } 
        result = this.calcPara(result)
      }
      this.displayLines = result.displayLines;
      this.result = result;
    },
    isHasTime() {
      return this._isHasTime
    },
    findCurNum(s) {
      return this._lyric.findCurNum(s * 1000);
    },
    setActivedByTxt(txt) {
      let { displayLines } = this.result;
      let index = displayLines.findIndex(item => {
        return item.txt == txt;
      });
      if (index > -1) {
        this.handleLyric({
          lineNum: index,
          txt
        })
      } else {
        this.currentLineNum = -1;
      }
    },
    reset() {
      this.handleLyric({
        lineNum: -1,
        txt: ''
      })
    },
    calcPlayLines(result) {
      let { displayLines } = result;
      let lines = this._lyric.lines;
      lines.forEach((line, index) => {
        let txts = (line.txt || '').split('');
        line.ws = txts;
        if (displayLines.length == 1) {
          line.time = 0;
        } else {
          if (index < lines.length - 1) {
            let nextLine = lines[index + 1];
            line.playTime = nextLine.time - line.time;
          }
        }
        line = this.getLineDuration(line, txts);
        displayLines[index] = {
          ...displayLines[index],
          ...line
        }
      });
      result = this.calcPara(result);
      result.paraGroups = result.paraGroups;
      result.displayLines = result.displayLines;
      return result;
    },
    getPartItem(partTemp, result, id) {
      let style = result.style;
      let firstItem = partTemp[0];
      let partTime = 0;
      if (firstItem.time) {
        firstItem.s = (firstItem.time - 100) / 1000;
      }
      if (style && style.textIndent) {
        firstItem.textIndent = style.textIndent;
      }
      partTemp.forEach((item) => {
        item.id = id
        partTime += item.playTime;
      })
      return {
        ...firstItem,
        startIndex: firstItem.rowIndex,
        endIndex: firstItem.rowIndex + partTemp.length,
        partTime,
        partLines: partTemp
      }
    },
    calcPara(result) {
      let paraGroups = []; // 段落集合
      let partTemp = [];
      let displayLines = result.displayLines;
      let startIndex = 0;
      const wordMapCnt = {}
      displayLines.forEach((line, i) => {
        partTemp.push(line);
        if (line.isPara && partTemp.length > 0) {
          let partItem = this.getPartItem(partTemp, result, paraGroups.length + 1);
          paraGroups.push(partItem);
          startIndex += partItem.partLines.length - 1;
          partTemp = [];
        }
        if (this.options?.isShowReport) this.processZhList(wordMapCnt, line)

      });
      if (paraGroups.length) {
        paraGroups.unshift({
          id: -1,
          name: '整篇'
        })
        if (partTemp.length) {
          let partItem = this.getPartItem(partTemp, result, paraGroups.length + 1);
          partItem.isLast = 1;
          paraGroups.push(partItem);
        }
      }
      result.paraGroups = paraGroups;
      return result;
    },
    processZhList (wordMapCnt, line) {
      const wordMap = this.wordMap;
      const reg = /[\u4e00-\u9fa5]/;
      line.words.forEach((wordItem) => {
        const zh = wordItem.zh
        if (wordMap) {
          let zhArray = zh.split('')
          let zhNewList = []
          zhArray.forEach((item) => {
            if (reg.test(item)) {
              if (!wordMapCnt[item]) {
                wordMapCnt[item] = 0
              }
              const key = `${item}_${wordMapCnt[item]}`;
              wordItem.level = wordMap[key];
                wordMapCnt[item]++
            }
          })
        }
      })
      return line
    },

    getLineDuration(line, txts, isLast) {
      let options = this.options;
      let stopTime = options.stopTime || 0;
      if (txts) {
        let playBuff = isLast ? 0 : (50 + stopTime)
        line.wordDuration = (line.playTime - this._timeBuff) / txts.length;
        line.playTime = line.playTime - playBuff;
        return line
      }
    },
    updateDuration(duration) {
      if (this._isUpdateDuration) {
        return;
      }
      this.duration = duration;
      if (this._isHasTime) {
        let { displayLines } = this.result;
        if (displayLines && displayLines.length > 0) {
          let lastItem = displayLines[displayLines.length - 1];
          if (lastItem) {
            let playTime = duration * 1000 - lastItem.time;
            lastItem.playTime = playTime;
            lastItem = this.getLineDuration(lastItem, lastItem.ws, true);
            displayLines[displayLines.length - 1] = lastItem;
          }
        }
        this.result.displayLines = displayLines;
        this._isUpdateDuration = true;
      }
      this.$emit('onReady', this.result);
    },
    async handleLyric({ lineNum, txt }) {
      let displayLines = this.result.displayLines;
      let displayLine = lineNum >= 0 ? displayLines[lineNum] : null
      this.displayLine = displayLine;
      this.currentLineNum = lineNum;
      if (this._isHasTime) {
        this.getScrollTop(lineNum);
        this.$emit('onLineUpdate', { displayLine, lineNum, txt })
        this.$emit('onScroll', this.scrollTop)
      }
    },
    getScrollTop(lineNum) {
      if(lineNum < 1)return
      const parent = document.querySelector('.vue-scrollbar__wrapper');
      const sub = document.querySelector(`#line${lineNum}`)
      const y = parseInt(sub.offsetTop - parent.offsetTop) * (this.getKnowledgeSettings.size || 1);
      console.log(lineNum,'============')
      this.scrollTop = y;
      // let sumHeight = 0;
      // let options = this.options;
      // if (lineNum > 2) {
      //   this.lastLineNum = true;
      //   let _cacheHeight = this._cacheLineHeights[lineNum]
      //   if (!_cacheHeight) {
      //     for (let i = 3; i <= lineNum; i++) {
      //       let height = helpers.height(document.querySelector(`#line${i}`))
      //       sumHeight += height * (this.getKnowledgeSettings.size || 1);
      //       if (i == lineNum) {
      //         this.lastScrollTop = sumHeight;
      //         this.scrollTop = sumHeight
      //       }
      //     }
      //     this._cacheLineHeights[lineNum] = sumHeight;
      //   } else {
      //     this.lastScrollTop = _cacheHeight;
      //     this.scrollTop = _cacheHeight
      //   }
      // } else {
      //   if (this.lastScrollTop > 50) {
      //     this.scrollTop = 0;
      //   }
      // }
    },
    rowClickHandler(e) {
      this.$emit('onRowClick', e)
    },
    play() {
      if (!this._isHasTime) {
        return;
      }
      this._isPlay = true;
      this._lyric.play();
    },
    stop() {
      if (!this._isHasTime) {
        return;
      }
      this._isPlay = false;
      this._lyric.stop();
      this.scrollTop = 0;
      this.currentLineNum = -1;
    },
    pause() {
      if (!this._isHasTime) {
        return;
      }
      this._isPlay = false;
      this._lyric.pause();
      this.options.onPause && this.options.onPause();
    },
    resume() {
      if (!this._isHasTime) {
        return;
      }
      this._isPlay = true;
      this._lyric.resume();
    },
    seek(s) {
      if (!this.isHasTime) {
        return;
      }
      this._lyric && this._lyric.seek(s * 1000);
    },
    seekNoPlay(s) {
      if (!this.isHasTime) {
        return;
      }
      this._lyric && this._lyric.seekNoPlay(s * 1000);
    },
    getResult() {
      return this.result;
    },
    showAsPartNum(partNum) {
      this.partNum = partNum;
    },
    getAttr(line) {
      let attr = {};
      let attrTemps = line.split(';');
      attrTemps.forEach((n) => {
        let valueKeys = n.split('=');
        if (valueKeys && valueKeys.length > 1) {
          let val = valueKeys[1];
          if (!isNaN(parseInt(val, 10))) {
            val = parseInt(val, 10)
          }
          attr[`${valueKeys[0]}`.trim()] = val;
        }
      });
      if (attr.emptyRow && !attr.rowHeight) {
        attr.rowHeight = 45;
      }
      return attr;
    },
    getTime(str) {
      const timeExp = /\[(\d{2,}):(\d{2})(?:\.(\d{2,3}))?]/g;
      let result = timeExp.exec(str)
      if (result) {
        let time = result[1] * 60 * 1000 + result[2] * 1000 + (result[3] || 0) * 10;
        return time / 1000;
      }
    },
    splitWord(str) {
      let arr = str.split('');
      let newArr = []
      let spaceCnt = 0;
      let splitChar = ' ';
      let findNum = 0;
      arr.forEach((n, i) => {
        newArr.push(n);
        if (ZH_REG.test(n)) {
          let startIndex = i + spaceCnt
          let preWord = newArr[startIndex - 1];
          if (preWord != splitChar && findNum) {
            newArr.splice(startIndex, 0, splitChar);
            spaceCnt++;
          }
          findNum++
        }
      });
      return newArr.join('')
    },
    parse(str) {
      if (!str) {
        return;
      }
      let SPLITCAHR = '\n'; // 行分隔符
      // 过滤掉所有的<>结束时间，结束时间用于小程序的
      let oriLines = str.replaceAll(/<.*?>/g, '').split(SPLITCAHR); // 所有目标行数
      let timeReg = /\[(.*)\](.*)/g; // 时间戳的分隔符
      let lyricRows = []; // 歌词行集合
      let wordRows = []; // 显示行的集合
      let zhList = []; // 中文字符集合
      let pinyList = []; // 拼音字符集合
      let isHasTime = true;
      if (oriLines.length < 1) {
        return
      }
      let rowIndex = 0;
      // 标注字段
      let isSign = false; //开始和结束
      let rowSign = -1;
      let signId = -1; //标注序号【只会出现一次】
      let signIdx = 0; //序号累加
      // 行循环
      oriLines.forEach((line, alt) => {
        let isIndent = false; //是否缩进
        if (line && line.length) {
          if (line.includes('@textIndent=1')) {
            line = line.replace('@textIndent=1', '');
            isIndent = true;
          }
          let matchs = /(\[.*\])(.*)/g.exec(line);
          let time = '';
          let txtStyle = '';
          let txtOutput = [];
          let words = [];
          let txtStyleArr = [];
          let txt = ''
          let txtLineStyle = '';
          let lineArr = {}; // 行属性
          let wordRow = {};
          if (matchs && matchs.length > 2) {
            time = matchs[1];
            txtStyle = matchs[2] || '-';
          } else {
            console.log('-------isHasTime')
            txtStyle = line;
            isHasTime = false;
          }
          if (txtStyle) {
            txtStyleArr = txtStyle.split('@');
          }
          if (txtStyleArr.length > 0) {
            txt = txtStyleArr[0]
          }
          if (txtStyleArr.length > 1) {
            txtLineStyle = txtStyleArr[1];
            if (txtLineStyle) {
              lineArr = this.getAttr(txtLineStyle);
            }
          }
          if (txt) {
            txt = this.splitWord(txt);
            txt = txt.trim();
            txt = txt.replace(/\s+/g, ' ');
            txt = this.replaceHalfTo(txt)
            let txts = txt.replace("#zsd=1", ' #zsd=1').split(/\s{1}/);
            let cnt = 0;
            signId = -1;
            // 行内字处理
            txts.forEach((m, i) => {
              if (m) {
                if (m.includes('#zsd=1')) {
                  m = m.replace('#zsd=1', ' ').trim();
                  isSign = true;
                  rowSign = alt;
                  signIdx += 1;
                  signId = signIdx;
                }
                let isEndSign = m.includes('#zsd=2');
                if (isEndSign) m = m.replace('#zsd=2', ' ');
                const pyReg = /.*\((.*)\)/g;
                const matchs1 = pyReg.exec(m);
                let py;
                let pys = []
                let zh = m;
                let zhs;
                // let level = 0;
                let wordAttr = {};
                if (matchs1 && matchs1.length > 1) {
                  py = matchs1[1];
                  if (py) {
                    pys = py.split('|');
                    if (pys.length > 1) {
                      if (pys[0]) {
                        py = pys[0]
                      } else {
                        py = ''
                      }
                    } else {
                      py = pys[0];
                    }
                  }
                }
                zh = m.replace(/\(.*\)/g, '');
                zhs = zh.split('@');
                if (zhs.length > 0) {
                  zh = zhs[0];
                }
                zhs = zh.split('$');
                if (zhs.length > 0) {
                  zh = zhs[0];
                }
                if (zhs.length > 1) {
                  wordAttr = this.getAttr(zhs[1]);
                }
                txtOutput.push(zh);
                let wordItem = {
                  zh,
                  py,
                  isSign,
                  signId: signIdx,
                  allZh: zh,
                  sign: zh.includes('#zsd=1') ? 1 : 2,
                  isIndent,
                  ...wordAttr
                }
                isIndent = false;
                if (isEndSign) isSign = false;
                if (py && !(CHAR_REG_RIGHT.test(zh) && CHAR_REG_LEFT.test(zh))) {
                  if (CHAR_REG_LEFT.test(zh)) {
                    wordItem.markIsLeft = 1;
                    if (zh) {
                      let matchs2 = zh.match(/([《》。，;；：？！……——“”（）、]+)([\u4e00-\u9fa5]+)/);
                      if (matchs2 && matchs2.length > 2) {
                        wordItem.zh = matchs2[2]
                        wordItem.mark = matchs2[1];
                        wordItem.allZh = zh;
                      }
                    }
                  } else if (CHAR_REG_RIGHT.test(zh)) {
                    wordItem.markIsRight = 1;
                    if (zh) {
                      let matchs2 = zh.match(/([\u4e00-\u9fa5]+)([《》。;；：？！……——“”（）、]+)/);
                      if (matchs2 && matchs2.length > 2) {
                        wordItem.zh = matchs2[1]
                        wordItem.mark = matchs2[2];
                        wordItem.allZh = zh;
                      }
                    }
                  }
                }
                if (zh) {
                  zhList.push(zh);
                }
                if (py) {
                  pinyList.push(py);
                }
                if (zh) {
                  words.push(wordItem);
                  if (py && py.length >= 3) {
                    wordItem.minWidth = py.length;
                  }
                  if (zh == '——') {
                    wordItem.isDash = 1;
                  }
                }
                if (cnt > 0) {
                  let pre = words[cnt - 1];
                  let next = words[cnt];
                  if (pre && next && pre.py && next.py) {
                    let len = (pre.py + next.py).length;
                    if (pre && next && len >= 6) {
                      words[cnt - 1].isRight = 1;
                      words[cnt].isLeft = 1;
                    }
                  }
                }
                cnt++;
              }
            })
            let lyricTxt = txtOutput.join('');
            let lyricTxtTime = [time, lyricTxt].join('');
            lyricRows.push(lyricTxtTime);
            wordRow = {
              txt: lyricTxt,
              name: lyricTxt,
              fullTxt: txt,
              words,
              rowIndex,
              rowSignIdx: rowSign > -1 ? signIdx : -1,
              signId,
              ...lineArr
            }
            if (!isSign) rowSign = -1;
            wordRows.push(wordRow);
            rowIndex++;
          }
        }
      });
      let wordPageStyle = 0;
      if (pinyList.length < 1) {
        wordPageStyle = 1;
      } else {
        if (pinyList.length < zhList.length * .5) {
          wordPageStyle = 2;
        }
      }
      const ret = {
        wordPageStyle,
        lyricText: lyricRows.join('\n'),
        displayLines: wordRows,
        isHasTime
      }
      if (wordRows.length > 0) {
        let firstRow = wordRows[0];
        if (firstRow.textAlign) {
          ret.style = {
            textAlign: firstRow.textAlign,
            textIndent: firstRow.textIndent || 30
          }
        }
      }
      return ret;
    },
    replaceHalfTo(str) {
      var tmp = ''
      for (var i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i)
        if (char >= 33 && char <= 126 && CHAR_REG_FULL_HALF.test(str[i])) {
          // 如果位于半角!到半角~区间内 (33-126) 半角空格 是 32 与半角符号都均相差65248
          tmp += String.fromCharCode(str.charCodeAt(i) + 65248)
        } else {
          // 不处理半角空格，半角!到半角~区间外的字符
          tmp += str[i]
        }
      }
      return tmp
    }
  }
}
</script>
<style lang="less" scoped></style>